export default __webpack_public_path__ + "static/cashflow_new_1-5e648babb17740f076c95c33b23e393a.jpg";